module.exports = __webpack_public_path__ + "img/vendor-active.57bc876a.svg";